import red from "../Img/Emoji/red.png";
import orange from "../Img/Emoji/orange.png";
import yellow from "../Img/Emoji/yellow.png";
import blue from "../Img/Emoji/blue.png";
import purple from "../Img/Emoji/purple.png";
import green from "../Img/Emoji/green.png";
import pink from "../Img/Emoji/pink.png";
import grey from "../Img/Emoji/grey.png";
import dgrey from "../Img/Emoji/dgrey.png";
import dblue from "../Img/Emoji/dblue.png";
import violet from "../Img/Emoji/violet.png";

const EmojiList = [
  [red, "eb4c36"],
  [orange, "ff7e00"],
  [yellow, "ffb901"],
  [green, "0ac765"],
  [blue, "157dfb"],
  [dblue, "435fd8"],
  [purple, "8d40ee"],
  [violet, "d843d1"],
  [pink, "ff65a6"],
  [grey, "dcdcdc"],
  [dgrey, "939393"],
];

export default EmojiList;
